import React, { useEffect, useState } from 'react';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import './../SidePanelTabs.css';
import { getSystemAdminUser } from '../../../service/UserService';
import AdminUserOverview from './UserOverview/AdminUserOverview';

export default function AdminUserTabs(props) {
    const overviewTab = "overview";
    const [activeTab, setActiveTab] = useState("");
    const [user, setUser ] = useState({});

    useEffect(() => {
        if (props?.uuid) {
            const dataHandler = (userData) => {
                if (userData) {
                    const getUser = {
                        uuid: userData.user.uuid,
                        username: userData.user.username,
                        customerId: userData.user.ccOrgId,
                        isActive: userData.user.isActive,
                        internalRole: {
                            roleUuid: userData.user.internalRoleUuid,
                            roleName: userData.user.internalRoleName
                        },
                        permissions: userData.user.permissions,
                        isSuper: userData.user.isSuper,
                        companies: userData.user.companies,
                        createdDate: userData.user.createdDate,
                        name: userData.user.name
                    }
                    setUser(getUser);
                    setActiveTab(overviewTab);
                }
            };

            getSystemAdminUser(props.uuid, dataHandler);
        }
    }, [props.uuid]);

    function handleTabSelection(tab) {
        // Avoid excess reassignment
        if (tab !== activeTab) {
            setActiveTab(tab);
        }
    }

    function retrieveContent() {
        switch (activeTab) {
            case overviewTab:
                return (<AdminUserOverview user={user} updateUser={props.updateUser}/>);
            default:
                return (<LoadingSpinner blue data-testid="efup-tabs-loading-spinner" />);
        }
    }

    return (
        <React.Fragment>
            <div className="efup-tab-component" data-testid="efup-tabs-component">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === overviewTab ? "active" : ""}`}
                            id="overview-tab"
                            type="button"
                            onClick={() => handleTabSelection(overviewTab)}
                            data-testid="efup-overview-tab"
                        >
                            Overview
                        </button>
                    </li>
                </ul>
            </div>
            <div className="offcanvas-body">
                <div className="d-lg-block">
                    <div className="tab-content" id="myTabContent">
                        {retrieveContent()}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}